import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";

@Injectable()
export class AttendanceViewService {
	constructor(private httpclientService: HttpclientService) {}

	SchoolAdminAttendanceGetlist(SchoolID, StartDate) {
		var postResult$ = new Subject();
		var url = "dynamicreport/SchoolAdminAttendanceGetlist?SchoolID=" + SchoolID + "&startdate=" + StartDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	SchoolAdminAttendanceDetailGetList(ClassAttendanceID) {
		var postResult$ = new Subject();
		var url = "dynamicreport/SchoolAdminAttendanceDetailGetList?ClassAttendanceID=" + ClassAttendanceID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
